import { render, staticRenderFns } from "./ModalSendImpayes.vue?vue&type=template&id=c142670e&"
import script from "./ModalSendImpayes.vue?vue&type=script&lang=js&"
export * from "./ModalSendImpayes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports